<template>
    <div id="app">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">系统管理</a></el-breadcrumb-item>
            <el-breadcrumb-item>系统列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 卡片视图区域 -->
        <el-card>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-button type="primary" @click="addDialog = true">系统公告添加</el-button>
                </el-col>
            </el-row>

            <el-table :data="XitongList" border stripe>
                <el-table-column type="index" label="#"></el-table-column>
				<!-- <el-table-column label="汽车名称"> -->
                <el-table-column prop="title" label="公告标题"></el-table-column>
                <el-table-column prop="content" label="内容"></el-table-column>
                <el-table-column prop="time" label="时间"></el-table-column>
                <el-table-column label="操作" width="180px">
                    <template slot-scope="scope">
                       
                        <el-button type="danger" icon="el-icon-delete" size="mini"
							@click="del(scope.row.id)"></el-button>
                       
                    </template>
                </el-table-column>
				
            </el-table>

            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageNum" :page-sizes="[2, 4, 6, 8]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </el-card>

        <!-- 添加用户得对话框 -->
       <el-dialog title="系统公告添加" :visible.sync="addDialog" width="40%" @close="addDialogClosed">
            <span>
                <el-form ref="addFormRef" :model="addForm" label-width="70px">
                    <el-form-item label="公告标题">
                        <el-input v-model="addForm.title"></el-input>
                    </el-form-item>
					<el-form-item label="内容">
					    <el-input v-model="addForm.content"></el-input>
					</el-form-item>
					<el-form-item label="时间">
					    <el-input v-model="addForm.time"></el-input>
					</el-form-item>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialog = false">取 消</el-button>
                <el-button type="primary" @click="addQiche">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { Xitongadd, XitongList,Xitongdel} from '@/api/index.js'
export default {
    data() {
        return {
            XitongList: [],
            selectUserObj: {},
			pageNum:1,
			pageSize:10,
			addForm:{
				title:'',
				content:'',
				time:'',
			},
            editForm: {},
            addDialog: false,
            editDialog: false,
            total: 0,
			fileList:[]
        }
    },
    created() {
        this.getXitongList();
    },
    methods: {		    
        async getXitongList() {
            const { data: res } = await XitongList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            });
			console.log(res)
            this.XitongList = res.data.list;
            this.total = res.data.total;
        },
        handleSizeChange(newsize) {
            this.pageSize = newsize;
            this.getXitongList();
        },
        handleCurrentChange(newnum) {
            this.pageNum = newnum;
            this.getXitongList();
        },
        addDialogClosed() {
            this.addForm.username = "";
            this.addForm.password = "";
        },
		async addQiche(){
			//请求我的接口
			console.log(this.addForm);
			const { data: res } = await Xitongadd(this.addForm);
			if(res.code==200){
				this.$message.success('添加成功');
				this.getXitongList();
				this.addDialog = false;
			}else{
				this.$message.success('添加失败');
			}
		},
		async del(id){
			const { data: res } = await Xitongdel({id});
			if(res.code==200){
				this.$message.success('删除成功');
				this.getXitongList();
			}else{
				this.$message.success('删除失败');
			}
		},
		successimg(response){
			console.log(response);
			this.addForm.img = response.pic;
		}
		
    }
}
</script>
<style scoped>
.el-card {
    margin-top: 20px;
}

.el-row {
    margin-bottom: 20px;
}
</style>